import { push } from 'redux-first-history';

import * as constants from '../constants';
import { store } from '../index';
import { getPathname } from '../utils/paths';
import { Dispatch } from 'redux';
import { SchemaStandarderror } from '@repo/legacy-commerce-api';

export interface ACTION {
  type: string;
  payload?: any;
}

export const logOut = (): ACTION => {
  (window as any).sessionStorage.removeItem('bearerTokenEC');
  (window as any).sessionStorage.removeItem('refreshTokenEC');
  return {
    type: constants.LOG_OUT,
  };
};

export const setLoading = (payload: Object): ACTION => ({
  type: constants.LOADING,
  payload,
});

export const clearData = (payload: Object): ACTION => ({
  type: constants.CLEAR_DATA,
  payload,
});

export const keycloakMessage = (payload: any): ACTION => ({
  type: constants.KEYCLOAK_STATE,
  payload,
});

export const receivedNotice = (payload: any): ACTION => ({
  type: constants.NOTICE_RECEIVED,
  payload,
});

export const clearError = (payload: SchemaStandarderror | null): ACTION => ({
  type: constants.CLEARED_ERROR,
  payload,
});

// This unfortunately does not match the InfoObject, which is the notices API object. Frontend uses "urn" here:
export const clearNotice = (payload: any): ACTION => ({
  type: constants.CLEARED_NOTICE,
  payload,
});

// handling errors from redux-thunk async action creators
// source: https://thecodebarbarian.com/async-await-with-react-and-redux-thunk
export const wrap = (fn: any, type = ''): any => {
  return function (dispatch: Dispatch) {
    return fn(dispatch).catch((error: any) => {
      if (!String(error as any).includes('The user aborted a request')) {
        console.log('error', error);
        try {
          console.log('type', type);
          let errorJson = JSON.parse(error);
          console.log('type json', errorJson);
          if (errorJson.code != 1001) {
            dispatch({ type, payload: errorJson });
          }
        } catch (e) {
          return e;
        }
      }
    });
  };
};

export const wrapAndThrowError = (fn: any, type = ''): any => {
  return function (dispatch: Dispatch) {
    return fn(dispatch).catch((error: any) => {
      console.log('error', error);
      try {
        let errorJson = JSON.parse(error);
        dispatch({ type, payload: errorJson });
        // eslint-disable-next-line
        // toastr.error(errorJson.status + ': Etwas ist schief gelaufen!', errorJson.details, {timeOut: 0});
      } catch (e) {
        throw e;
      }
      throw error;
    });
  };
};

export const handleError = (code: string, errorClass: string, journey2: boolean) => {
  const codeNumber = Number(code);

  const codeMapping: Record<number, () => void> = {
    1000: () => {
      store.dispatch(
        push({
          search: `?error=true`,
        }),
      );
      store.dispatch(clearError({ code: codeNumber, class: errorClass }));
    },
    1001: () => {
      if (journey2) {
        store.dispatch(
          push({
            pathname: getPathname(store.getState().app.containers)(2),
          }),
        );
      } else {
        store.dispatch(
          push({
            pathname: `/journey1/4`,
          }),
        );
      }
      store.dispatch(clearError({ code: codeNumber, class: errorClass }));
    },
    1002: () => {
      if (journey2) {
        const isIndustryDefined = Boolean(store.getState().app.userDataEC.industry);
        store.dispatch(
          push({
            pathname: getPathname(store.getState().app.containers)(isIndustryDefined ? 3 : 2),
          }),
        );
      } else {
        store.dispatch(
          push({
            pathname: `/journey1/5`,
          }),
        );
      }
      store.dispatch(clearError({ code: codeNumber, class: errorClass }));
    },
    1003: () => {
      if (journey2) {
        store.dispatch(
          push({
            pathname: getPathname(store.getState().app.containers)(2),
          }),
        );
      } else {
        store.dispatch(
          push({
            pathname: `/journey1/5`,
          }),
        );
      }
      store.dispatch(clearError({ code: codeNumber, class: errorClass }));
    },
    1006: () => {
      // user should go to Anpassen and change date
      if (journey2) {
        store.dispatch(
          push({
            pathname: getPathname(store.getState().app.containers)(3),
          }),
        );
      }
    },
  };
  if (codeNumber in codeMapping) {
    return codeMapping[codeNumber]();
  } else {
    console.error('Unhandled error, consult with the developer to handle this case');
  }
};
